export default "__VITE_ASSET__BuguZ8Gn__"